/*global google*/
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Col, Alert } from 'react-bootstrap/lib';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, OverlayView, InfoWindow, Polyline } from "react-google-maps";
import { MyLocButton } from '../generic/input';
import MapControl from './mapControl';
import { StampTODate, timeFormat } from "../lib/dtconv";
const { VEH_SHIP_STATS, ARROW, ICON, TODAY_START_TS_IN_SEC, MAPS_API_KEY } = require('../lib/enums');
const { Circle } = require("react-google-maps/lib/components/Circle");
const staticMarker = require('../images/staticMarker.png');
const greyMarker = require('../images/greyMarker.png');
const greenMarker = require('../images/greenMarker.png');
const ajjasMarker = require('../images/ajjas-marker.png');
const BLUE_ARROW = Object.assign({ "fillColor": "#00a8e2" }, ARROW);
const GREEN_ARROW = Object.assign({ "fillColor": "#6ac803" }, ARROW);
const GREY_ARROW = Object.assign({ "fillColor": "#9b9b9b" }, ARROW);
const BLUE_ICON = Object.assign({ "url": staticMarker }, ICON);
const GREEN_ICON = Object.assign({ "url": greenMarker }, ICON);
const GREY_ICON = Object.assign({ "url": greyMarker }, ICON);

export default class MapDisplay extends Component {
  constructor(props) {
    super(props);
    this.zoom = 13;
    this.center = { lat: 20.5837, lng: 78.9629 };
    this.maxZoom = 18;
    this.showInfoBox = new Set();
    this.showGfInfoBox = new Set();
    this.vehicleModal = {};
    this.vehicleNum = {};
    this.handleMapMounted = this.handleMapMounted.bind(this);
    this.isDrag = false;
    this.pingData = this.props.pingData;
    this.lastSeenData = {};
    this.pathData = {};
    this.currentVeh = null;
    this.vidTsMap = {};
  }

  componentDidMount() {
    this.acceptLastSeen(this.props.lastSeenData);
    global.EE.addEventListener(global.EE.EVENT_TYPES.LOCATION_EVENTS, this.handleLocEvents);
  }

  componentWillUnmount() {
    global.EE.removeEventListener(global.EE.EVENT_TYPES.LOCATION_EVENTS, this.handleLocEvents);
  }

  acceptLastSeen(lastSeen) {
    this._filterSelectedVehLastSeenData(lastSeen);
  }

  _filterSelectedVehLastSeenData(lastSeen) {
    this.lastSeenData = {};
    if (this.props.selectedVeh && this.props.selectedVeh.length) {
      this.props.selectedVeh.forEach(veh => {
        if (lastSeen && lastSeen[veh.idx]) {
          this.vehicleModal[veh.idx] = veh.mo;
          this.vehicleNum[veh.idx] = veh.reg;
          this.lastSeenData[veh.idx] = lastSeen[veh.idx];
        }
        
        if (this.pathData[veh.idx]) {
          if (
            (lastSeen[veh.idx].motion || lastSeen[veh.idx].ignition) &&
              lastSeen[veh.idx].lat && lastSeen[veh.idx].lng) {
            this.pathData[veh.idx] = this.pathData[veh.idx].concat(lastSeen[veh.idx]);
          }
        }
      });

      this.forceUpdate(() => {
        if (!this.mapMounted) this.handleMapMounted();
      });
    }
  }

  _onChange(latlng, zoom) {
    if (this.maxZoom === 18) {
      this.maxZoom++;
      return;
    } else this.forceUpdate();
    this.maxZoom++;
    if (this.props.selectedVeh && this.props.selectedVeh.length === 1) {
      this.center = latlng;
      this.forceUpdate();
    }
  }

  changeMapstate = () => {
    this.mapMounted = false;
  }

  handleMapMounted(cb) {
    if (this.mapMounted) return;
    if (Object.keys(this.lastSeenData).length === 1) {
      var data = Object.values(this.lastSeenData)[0];
      var latlng = { lat: data.lat, lng: data.lng };
      if (!this.isDrag) this.center = latlng;
      this.zoom = 16;
      this.forceUpdate();
    }
    else if (Object.keys(this.lastSeenData).length > 1 && this._ref) {
      this.fitToBounds(cb);
    }
  }

  fitToBounds(cb) {
    if (!this._ref) return;
    var bounds = new window.google.maps.LatLngBounds();
    Object.keys(this.lastSeenData).forEach((key) => {
      if (this.lastSeenData[key] && this.lastSeenData[key].lat && this.lastSeenData[key].lng) {
        var latLng = new window.google.maps.LatLng(parseFloat(this.lastSeenData[key].lat, 10), parseFloat(this.lastSeenData[key].lng, 10))
        if (latLng) bounds.extend(latLng);
      }
    });
    this._ref.fitBounds(bounds);
    if (cb) cb();
  }

  displayInfoBox(key) {
    this.currentVeh = null;

    if (this.showInfoBox.has(key)) {
      this.showInfoBox.delete(key);
    } else {
      this.showInfoBox.clear();
      this.showInfoBox.add(key);
      // this.handlePath(key);
    }
    this.forceUpdate();
  }

  mouseOver(vid) {
    if (this.showBox) this.showBox = null;
    else this.showBox = vid;
    this.forceUpdate();
  }

  handleMyLoc = () => {
    this.isDrag = false;
    if (Object.keys(this.lastSeenData).length === 1) this.fitToBounds();
    else {
      this.mapMounted = false;
      this.handleMapMounted();
    }
  }

  handleDrag = () => {
    this.isDrag = true;
  }

  OnGeoFenceClick = (key) => {
    this.showGfInfoBox.add(key);
    this.forceUpdate();
  }

  onGFToggleClose = (key) => {
    if (this.showGfInfoBox.has(key)) {
      this.showGfInfoBox.delete(key);
      this.forceUpdate();
    }
  }

  getMapIcon(data) {
    let icon = {};
    var vid = data.vid;
    var status = this.props.vehicleStatus[vid];

    if (status) {
      if (status === VEH_SHIP_STATS.AT_SRC_START || status === VEH_SHIP_STATS.AT_SRC_END) {
        if (data.ignition) {
          icon = Object.assign(icon, GREY_ARROW);
          icon.rotation = data.brg;
        }
        else icon = Object.assign(icon, GREY_ICON);
      }
      else if (status === VEH_SHIP_STATS.ENROUTE_DEST || status === VEH_SHIP_STATS.AT_DEST) {
        if (data.ignition) {
          icon = Object.assign(icon, GREEN_ARROW);
          icon.rotation = data.brg;
        }
        else icon = Object.assign(icon, GREEN_ICON);
      }
      else if (status === VEH_SHIP_STATS.ENROUTE_SRC) {
        if (data.ignition) {
          icon = Object.assign(icon, BLUE_ARROW);
          icon.rotation = data.brg;
        }
        else icon = Object.assign(icon, BLUE_ICON);
      }
    }
    else {
      if (data.ignition) {
        icon = Object.assign(icon, BLUE_ARROW);
        icon.rotation = data.brg;
      }
      else icon = Object.assign(icon, GREY_ICON);
    }
    return icon;
  }

  onVehSubUnSub(vIds, isSubscribed){
    vIds.forEach((vId) => {
      if (this.pathData[vId] && !isSubscribed) {
        this.vidTsMap[vId] = this.pathData[vId][this.pathData[vId].length - 1].ts;

        if (this.showInfoBox.has(vId)) {
          this.currentVeh = null;
          this.showInfoBox.delete(vId);
        }
      }
    })
  }

  handlePath = (selectedVehicle) => {
    if (this.pathData[selectedVehicle]) {
      if (this.vidTsMap[selectedVehicle]) {
        const req = { 
          vid: selectedVehicle, 
          fromTs: this.vidTsMap[selectedVehicle],
          toTs: Math.floor(Date.now() / 1000)
        }

        global.gWebSocket.SendRequest({ data: { a: "getLocEvents", d: req }});
      }
      else {
        this.currentVeh = selectedVehicle;
        this.fitTrailToBounds(this.pathData[selectedVehicle]);
      }
    } else {
      const timelineData = { veh: [{ vid: selectedVehicle, wts: TODAY_START_TS_IN_SEC }] };
      const req = { a: "getTimelineEvents", d: timelineData };

      global.gWebSocket.SendRequest({ data: req });
      this.pathData[selectedVehicle] = [];
    }
  }

  handleLocEvents = ({ obj: ping }) => {
    if (ping.ts > 0) {
      if ((ping.motion || ping.ignition) && ping.lat && ping.lng) {
        this.pathData[ping.vid] = this.pathData[ping.vid].concat(ping);
      }
    } else {
      this.pathData[ping.vid].sort((a, b) => a.ts - b.ts);

      this.currentVeh = ping.vid;
      this.fitTrailToBounds(this.pathData[ping.vid]);

      this.forceUpdate();
    }
  }
  
  fitTrailToBounds = (pathTrail) => {
    const bounds = new window.google.maps.LatLngBounds();

    pathTrail.forEach((trailPoint) => {
      bounds.extend(new window.google.maps.LatLng(trailPoint.lat, trailPoint.lng));
    });

    this._ref.fitBounds(bounds);
  }

  MapDisplay() {
    return (
      <MapComponent
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${MAPS_API_KEY}&v=3.exp&libraries=drawing,places`}
        loadingElement={<Col style={{ height: '100%' }} />}
        containerElement={<Col style={{ height: '70vh', marginBottom: "15px" }} />}
        mapElement={<div style={{ height: '100%' }} />}
        center={this.center}
        zoom={this.zoom}
        onZoomChanged={() => this._onChange(this.center, this.zoom)}
        trafficCheck={false}
        markers={this.lastSeenData}
        onMapIdle={() => {
          if (!this.mapMounted) {
            this.handleMapMounted();
            this.mapMounted = true;
          }
        }}
        reference={(ref) => this._ref = ref}
        maxZoom={this.maxZoom}
        onPopupClick={(key) => this.displayInfoBox(key)}
        displayInfoBox={[...this.showInfoBox]}
        vehicleModal={this.vehicleModal}
        vehicleNum={this.vehicleNum}
        pingData={this.pingData}
        onMyLocation={this.handleMyLoc}
        onDrag={this.handleDrag}
        showGf={this.props.gfData ? this.props.gfData : null}
        OnGeoFenceClick={(key) => this.OnGeoFenceClick(key)}
        openGfInfoBox={[...this.showGfInfoBox]}
        onGFToggleClose={(key) => this.onGFToggleClose(key)}
        getMapIcon={(key) => this.getMapIcon(key)}
        mouseOver={(key, vid) => this.mouseOver(key, vid)}
        showBox={this.showBox}
        pathData={this.pathData}
        currentVeh={this.currentVeh}
      />
    )
  }

  render() {
    return (
      <Col lg={12} md={12} sm={12}>
        {Object.keys(this.lastSeenData).length > 0 ? this.MapDisplay() : <Alert bsStyle="warning">Map an ajjas device to track these vehicles</Alert>}
      </Col>
    )
  }
}

const MapComponent = withScriptjs(withGoogleMap((props) =>
  <GoogleMap
    zoom={props.zoom}
    center={props.center}
    onZoomChanged={props.onZoomChanged}
    options={{ scaleControl: true, streetViewControl: false, maxZoom: props.maxZoom }}
    onIdle={props.onMapIdle}
    ref={props.reference}
    onDrag={props.onDrag}
  >
    {props.showGf ?
      props.showGf.map((d, key) => {
        return (
          <Circle
            key={key}
            radius={d.r}
            center={{ lat: d.clat, lng: d.clong }}
            editable={false}
            clickable={false}
            options={{ fillColor: "#AF90FF", strokeWeight: "0", fillOpacity: 0.6 }}
            zIndex={1}
            onClick={(e) => props.OnGeoFenceClick(d)}
          />
        )
      })
      : null}
    <MapControl position={google.maps.ControlPosition.RIGHT_BOTTOM}>
      <MyLocButton onClick={() => props.onMyLocation()} />
    </MapControl>
    {

      Object.keys(props.markers).length > 0 ?
        Object.keys(props.markers).map((key) => {
          if (props.markers[key] && props.markers[key].lat) {
            var newicon = props.getMapIcon(props.markers[key]);
            return (
              <Marker key={key} position={{ lat: props.markers[key].lat, lng: props.markers[key].lng }}
                icon={newicon}
                onClick={(e) => props.onPopupClick(+key)}
                onMouseOver={(e) => props.mouseOver(+key)}
                onMouseOut={(e) => props.mouseOver(+key)}
              />
            )
          }
          else return null
        }) : null
    }
    {
      props.showBox ?
        <OverlayView key={Math.random()}
          position={{ lat: props.markers[props.showBox].lat, lng: props.markers[props.showBox].lng }}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        >
          <div>
            <InfoWindowData data={props.markers[props.showBox]} vehicleModal={props.vehicleModal[props.showBox] ? props.vehicleModal[props.showBox] : ""} vehicleNum={props.vehicleNum[props.showBox] ? props.vehicleNum[props.showBox] : ""} pingData={props.pingData && props.pingData[props.showBox] ? props.pingData[props.showBox] : null} />
          </div>
        </OverlayView>
        : null
    }

    {
      Object.keys(props.markers).length > 0 ?
        Object.keys(props.markers).map((key, i) => {
          var veh = props.markers[key].vid;
          if (props.markers[key] && props.markers[key].lat)
            return (
              <OverlayView key={Math.random()}
                position={{ lat: props.markers[key].lat, lng: props.markers[key].lng }}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                <div onClick={() => { props.onPopupClick(veh) }}>
                  {
                    props.displayInfoBox.length && (props.displayInfoBox.indexOf(veh) > -1) ?
                      <InfoWindowData data={props.markers[key]} vehicleModal={props.vehicleModal[key] ? props.vehicleModal[key] : ""} vehicleNum={props.vehicleNum[key] ? props.vehicleNum[key] : ""} pingData={props.pingData && props.pingData[key] ? props.pingData[key] : null} />
                      : null
                  }
                </div>
              </OverlayView>
            )
          else return null
        }) : null
    }
    {
      props.openGfInfoBox && props.openGfInfoBox.length ?
        props.openGfInfoBox.map((d, key) => {
          return (
            <InfoWindow key={key} onCloseClick={(e) => props.onGFToggleClose(d)} position={{ lat: d.clat, lng: d.clong }}>
              <div>
                <p className="margin0">{d.title}</p>
                <Link style={{ color: "#0094de" }} to={"/webapptl/gf/edit?tid=" + d.idx}>Edit</Link>
              </div>
            </InfoWindow>
          )
        })
        : null
    }
    {
      props.pathData[props.currentVeh] &&
      props.pathData[props.currentVeh].length && (
        <>
          <Polyline
            path={props.pathData[props.currentVeh]}
            options={{ strokeColor: "#217dbb", geodesic: true }}
          />
          <Marker
            position={props.pathData[props.currentVeh][0]}
            icon={{ url: ajjasMarker, anchor: { x: 20, y: 12 }, scaledSize: { height: 40, width: 34 } }}
          />
        </>
    )}
  </GoogleMap>
))

const InfoWindowData = (props) => {
  var isDevicePing = props.data.vid ? true : false;
  if (props.pingData) {
    return (
      <div style={{ backgroundColor: 'white', padding: "7px", maxWidth: "200px" }}>
        <p className="margin0"><span className="online-offline" style={{ background: 'rgb(199, 76, 17)' }}></span>{props.vehicleModal + " " + props.vehicleNum + " GPS Not Fixed"}</p>
        {props.pingData && props.pingData.ts ? <p className="margin0">Last Ping Sent At: <b>{StampTODate(props.pingData.ts * 1000) + " " + timeFormat(props.pingData.ts * 1000, true)}</b></p> : null}
        {props.data && props.data.ts ? <p className="margin0">Last Location Updated At: <b>{StampTODate(props.data.ts * 1000) + " " + timeFormat(props.data.ts * 1000, true)}</b></p> : null}
        <p className="margin0">{"Ignition: " + (props.pingData.ignition ? "Ignition On" : "Ignition Off")}</p>
        <p className="margin0">{props.pingData.relayState ? "Status of Bike : Locked" : "Status of Bike : Unlocked"}</p>
      </div>
    )
  }
  else {
    return (
      <div style={{ backgroundColor: 'white', padding: "7px", maxWidth: "200px", cursor: "pointer", fontSize: "12px" }}>
        <p className="margin0"><b><span className="online-offline" style={{ background: (props.data.ignition ? 'rgb(66, 183, 42)' : '#fddc33') }}></span>{props.vehicleModal + " " + props.vehicleNum}</b></p>
        <p className="margin0"><b>{(props.data.ignition ? " Online:" : " Last Seen : ")}</b></p>
        <p className="margin0"><b>{props.data.ts ? StampTODate(props.data.ts * 1000) + " " + timeFormat(props.data.ts * 1000, true) : "-"}</b></p>
        <p className="margin0">{props.data.spd !== null ? "Speed: " + props.data.spd.toFixed(2) + " km/hr" : "-"}</p>
        {isDevicePing ? <p className="margin0">{props.data.ignition ? "Ignition:   On" : "Ignition:  Off"}</p> : null}
        {(props.data.heartbeat && props.data.heartbeat.externalVolt) ? <p className="margin0">Battery Voltage: {props.data.heartbeat.externalVolt} V</p> : null}
      </div>
    )
  }
}
